// Catalog descriptions may contain rich text. Keep menu rendering plain text.
export function descriptionText(value) {
  const source = String(value ?? '');
  const document = new DOMParser().parseFromString(source, 'text/html');
  document.querySelectorAll('script, style, template').forEach(node => node.remove());
  document.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
  document.querySelectorAll('p, div, li, h1, h2, h3, h4, h5, h6').forEach(node => node.append('\n'));
  return (document.body.textContent || '').replace(/\s+/g, ' ').trim();
}
